import { effectInit } from 'swiper/effect-utils';
import { SwiperModule } from 'swiper/types';

export const OffsetCards: SwiperModule = ({ swiper, extendParams, on }) => {
  extendParams({
    offsetCards: {
      spacing: 8,
    },
  });

  on('slidesUpdated', () => {
    const paddingLeft = ((swiper as any).offsetCards?.spacing || 8) * 2;

    const width = Math.min(
      430, // Magic number from max width of view container
      swiper.el.offsetWidth + swiper.el.offsetLeft + swiper.el.offsetLeft,
    );

    if (!swiper.slides || swiper.slides.length === 0) {
      return;
    }

    const dx = (width - swiper.slides[0]!.clientWidth) / 2 - paddingLeft;

    swiper.snapGrid[0]! += dx;
    swiper.snapGrid[swiper.snapGrid.length - 1]! -= dx;

    swiper.slidesGrid = swiper.snapGrid.slice();
  });

  const setTranslate = () => {};

  const setTransition = (duration: number) => {
    for (const slideEl of swiper.slides) {
      if (duration > 0) {
        slideEl.style.transitionDuration = `${duration}ms`;
      }
    }
  };

  effectInit({
    effect: 'offsetCards',
    swiper,
    on: on as () => void,
    setTranslate,
    setTransition,
    perspective: () => true,
  });
};
